import { InferType, object, ref, string } from 'yup';

const passwordRules = string()
  .min(8, 'Password must be at least 8 characters')
  .matches(/\d/, 'Password must include a number')
  .matches(
    /[!@#$%^&*(),.?":{}|<>]/,
    'Password must include at least one special character'
  )
  .matches(/^\S*$/, 'Password can not include spaces');

const SignUpSchema = object({
  email: string().email('Email is invalid.').required('Email is required'),
  password: passwordRules.required('Password is required'),
  passwordConfirmation: passwordRules
    .oneOf([ref('password')], 'Your passwords do not match')
    .required('Please confirm your password'),
});

export type SignUpSchemaType = InferType<typeof SignUpSchema>;

export { SignUpSchema, passwordRules };
